import {z} from "zod";
import {UiReferenceFieldBaseSchema} from "./UiReferenceField";

export const SMART_REFERENCE_LIST_FIELD_COMPONENT_TYPE = 'SmartReferenceListField';

export const SmartReferenceListFieldSchema = UiReferenceFieldBaseSchema.extend({
    componentType: z.literal(SMART_REFERENCE_LIST_FIELD_COMPONENT_TYPE),
});

export type SmartReferenceListField = z.infer<typeof SmartReferenceListFieldSchema>;